import axios from "axios";
import {
    DOCUMENTS_SIGNABLE_ENDPOINT,
    SIGNING_CALLBACK_ENDPOINT, SIGNING_CANCEL_ENDPOINT,
    SIGNING_DOCUMENT_SIGNER_PUBLIC_ENDPOINT,
    SIGNING_ENDPOINT,
    SIGNING_PREFILLED_COMPANY_ENDPOINT, SIGNING_PREFILLED_CUSTOM_ENDPOINT, SIGNING_PREFILLED_PERSON_ENDPOINT
} from "@/constants/endpoints";
import SignerDTO from "@/dto/signature/SignerDTO";
import DeclineSignerPayload from "@/dto/signature/DeclineSignerPayload";
import QueryUtils from "@/utils/QueryUtils";
import authHeader from "@/services/auth-header";
import Page from "@/dto/taxation/Page";
import SignableDocumentsDTO from "@/dto/signature/SignableDocumentsDTO";
import SignableDocumentsFilter from "@/dto/signature/SignableDocumentsFilter";
import CreatePrefilledCompanyDocumentPayload from "@/dto/signature/CreatePrefilledCompanyDocumentPayload";
import SignersDTO from "@/dto/signature/SignersDTO";
import CreatePrefilledPersonDocumentPayload from "@/dto/signature/CreatePrefilledPersonDocumentPayload";
import CreateCustomSignableDocumentPayload from "@/dto/signature/CreateCustomSignableDocumentPayload";
import {Analytics} from "@/components/archive/SignableDocumentsListNew.vue";

export default new class SignatureService {

    public getSigner(publicId: string) {
        return axios.get<SignerDTO>(`${SIGNING_DOCUMENT_SIGNER_PUBLIC_ENDPOINT}/${publicId}`)
    }

    public sign(publicId: string, payload: FormData) {
        return axios.post(`${SIGNING_DOCUMENT_SIGNER_PUBLIC_ENDPOINT}/${publicId}/sign`, payload)
    }

    public declineSigner(publicId: string, payload: DeclineSignerPayload) {
        return axios.delete(`${SIGNING_DOCUMENT_SIGNER_PUBLIC_ENDPOINT}/${publicId}`, { data: payload })
    }

    public getSignableDocuments(filter: SignableDocumentsFilter) {
        const queryString = QueryUtils.objectToQueryString(filter);
        return axios.get<Page<SignableDocumentsDTO>>(`${SIGNING_ENDPOINT}${queryString}`, {headers: authHeader()})
    }

    public getAnalytics() {
        return axios.get<Analytics>(`${SIGNING_ENDPOINT}/analytics/`, {headers: authHeader()});
    }

    public createPrefilledCompanyDocument(payload: CreatePrefilledCompanyDocumentPayload){
        return axios.post(SIGNING_PREFILLED_COMPANY_ENDPOINT, payload, {headers: authHeader()});
    }

    public createPrefilledPersonDocument(payload: CreatePrefilledPersonDocumentPayload){
        return axios.post(SIGNING_PREFILLED_PERSON_ENDPOINT, payload, {headers: authHeader()});
    }

    public sendReminder(signerId: number) {
        return axios.put(`${SIGNING_ENDPOINT}/signer/${signerId}/reminder`, {}, {headers: authHeader()});
    }

    public getOwnToSign() {
        return axios.get<Array<SignersDTO>>(`${SIGNING_ENDPOINT}/own`, {headers: authHeader()});
    }

    public signOwn(signerId: number, payload: FormData) {
        return axios.post(`${SIGNING_ENDPOINT}/own/${signerId}/sign`, payload, {headers: authHeader()})
    }

    public getOwnSigner(id: number) {
        return axios.get<SignerDTO>(`${SIGNING_ENDPOINT}/own/${id}`, {headers: authHeader()});
    }

    public triggerCallback(documentId: number) {
        return axios.put(`${SIGNING_CALLBACK_ENDPOINT}/${documentId}`, null, {headers: authHeader()});
    }

    public buildCustomDocument(payload: CreateCustomSignableDocumentPayload){
        return axios.post(`${SIGNING_PREFILLED_CUSTOM_ENDPOINT}`, payload, {headers: authHeader()});
    }

    public cancelDocument(id: number){
        return axios.put<void>(`${SIGNING_CANCEL_ENDPOINT}/${id}`, null, {headers: authHeader()});
    }

}
